import { Card, CardContent, Typography } from "@mui/material";
import React from "react";

import Event1 from "../../../images/event1.jpg";
import CollectionsIcon from "@mui/icons-material/Collections";
import MovieIcon from "@mui/icons-material/Movie";
import CertificateIcon from "../../../images/icons/certificateIcon.png";
import ViewIcon from "../../../images/icons/viewIcon.png";
import "./notification.css";

const Notification = () => {
  return <div></div>;
};

export default Notification;
